import { render, staticRenderFns } from "./applicationRegister.vue?vue&type=template&id=c0c67ad6&scoped=true"
import script from "./applicationRegister.vue?vue&type=script&lang=js"
export * from "./applicationRegister.vue?vue&type=script&lang=js"
import style0 from "./applicationRegister.vue?vue&type=style&index=0&id=c0c67ad6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c67ad6",
  null
  
)

export default component.exports